// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction7_wrapper__1NHSz","button":"introduction7_button__YkFpU"};